// Automatización de Contratos Data

export const contractsHeroData = {
  tagline: "AUTOMATIZACIÓN DE CONTRATOS",
  title: "Contratos inteligentes para el comercio cloud",
  subtitle: "Estandariza, automatiza y firma contratos digitalmente. Integra flujos de firma electrónica tanto en tu marketplace como en procesos tradicionales de venta.",
  cta: "Comenzar ahora",
  secondaryCta: "Ver demo"
};

export const contractsStatsData = [
  { number: "80%", label: "Reducción tiempo de cierre" },
  { number: "100%", label: "Contratos digitales" },
  { number: "0", label: "Errores manuales" },
  { number: "24/7", label: "Firma disponible" }
];

export const standardizationFeaturesData = [
  {
    id: 1,
    title: "Templates Estandarizados",
    description: "Crea plantillas de contrato reutilizables con cláusulas predefinidas, variables dinámicas y lógica condicional según el tipo de servicio o cliente.",
    icon: "FileText"
  },
  {
    id: 2,
    title: "Cláusulas Inteligentes",
    description: "Biblioteca de cláusulas legales pre-aprobadas que se insertan automáticamente según el producto, región o tipo de cliente.",
    icon: "BookOpen"
  },
  {
    id: 3,
    title: "Versionado y Auditoría",
    description: "Historial completo de cambios en cada contrato con trazabilidad total para cumplimiento normativo.",
    icon: "History"
  },
  {
    id: 4,
    title: "Multi-idioma y Multi-región",
    description: "Genera contratos en múltiples idiomas con adaptación automática a requisitos legales locales.",
    icon: "Globe"
  }
];

export const marketplaceFlowData = {
  title: "Flujo Marketplace",
  description: "Automatiza la generación y firma de contratos directamente en el checkout de tu marketplace.",
  steps: [
    {
      id: 1,
      title: "Selección de Producto",
      description: "El cliente selecciona servicios cloud en tu marketplace white-label."
    },
    {
      id: 2,
      title: "Generación Automática",
      description: "El contrato se genera automáticamente con los términos del servicio seleccionado."
    },
    {
      id: 3,
      title: "Firma Electrónica",
      description: "El cliente firma digitalmente antes de completar la compra."
    },
    {
      id: 4,
      title: "Activación Inmediata",
      description: "El servicio se aprovisiona automáticamente tras la firma."
    }
  ],
  benefits: [
    "Checkout sin fricciones",
    "Cumplimiento legal automático",
    "Reducción de abandono de carrito",
    "Activación instantánea de servicios"
  ]
};

export const traditionalFlowData = {
  title: "Flujo Tradicional",
  description: "Integra firma electrónica en tus procesos de venta consultiva y enterprise.",
  steps: [
    {
      id: 1,
      title: "Propuesta Comercial",
      description: "El equipo de ventas genera una propuesta personalizada desde el CRM."
    },
    {
      id: 2,
      title: "Contrato Personalizado",
      description: "Se genera un contrato con términos negociados y aprobaciones internas."
    },
    {
      id: 3,
      title: "Envío para Firma",
      description: "El cliente recibe el contrato por email con link de firma segura."
    },
    {
      id: 4,
      title: "Seguimiento y Cierre",
      description: "Tracking en tiempo real del estado de firma con recordatorios automáticos."
    }
  ],
  benefits: [
    "Integración con CRM/ERP",
    "Aprobaciones multinivel",
    "Negociación de términos",
    "Contratos enterprise complejos"
  ]
};

export const eSignatureIntegrationsData = [
  {
    id: 1,
    name: "DocuSign",
    description: "Líder mundial en firma electrónica con validez legal en más de 180 países.",
    features: ["eSignature", "CLM", "Notary"],
    logo: "docusign"
  },
  {
    id: 2,
    name: "Adobe Sign",
    description: "Solución enterprise de Adobe con integración nativa en Creative Cloud y Acrobat.",
    features: ["PDF nativo", "Workflows", "API robusta"],
    logo: "adobe"
  },
  {
    id: 3,
    name: "SignaturIt",
    description: "Solución europea con cumplimiento eIDAS y especialización en mercados hispanos.",
    features: ["eIDAS", "Biometría", "Certificado"],
    logo: "signaturit"
  },
  {
    id: 4,
    name: "HelloSign",
    description: "Solución simple y developer-friendly, ahora parte de Dropbox.",
    features: ["API simple", "Dropbox", "Templates"],
    logo: "hellosign"
  }
];

export const contractLifecycleData = [
  {
    id: 1,
    title: "Creación",
    description: "Genera contratos desde templates o desde cero con editor visual.",
    icon: "FilePlus"
  },
  {
    id: 2,
    title: "Revisión",
    description: "Workflow de aprobación interna con comentarios y redlining.",
    icon: "FileSearch"
  },
  {
    id: 3,
    title: "Negociación",
    description: "Colaboración en tiempo real con clientes para ajustar términos.",
    icon: "MessageSquare"
  },
  {
    id: 4,
    title: "Firma",
    description: "Firma electrónica con validez legal y certificación.",
    icon: "PenTool"
  },
  {
    id: 5,
    title: "Almacenamiento",
    description: "Repositorio centralizado con búsqueda y acceso controlado.",
    icon: "Archive"
  },
  {
    id: 6,
    title: "Renovación",
    description: "Alertas automáticas y flujos de renovación predefinidos.",
    icon: "RefreshCw"
  }
];

export const complianceFeaturesData = [
  {
    id: 1,
    title: "eIDAS Compliance",
    description: "Firma electrónica cualificada según regulación europea.",
    icon: "Shield"
  },
  {
    id: 2,
    title: "GDPR Ready",
    description: "Gestión de consentimientos y derecho al olvido integrado.",
    icon: "Lock"
  },
  {
    id: 3,
    title: "Audit Trail",
    description: "Registro inmutable de todas las acciones sobre cada contrato.",
    icon: "ClipboardList"
  },
  {
    id: 4,
    title: "Retención Legal",
    description: "Políticas de retención configurables según normativa aplicable.",
    icon: "Scale"
  }
];

export const automationRulesData = [
  {
    id: 1,
    title: "Auto-generación",
    description: "Crea contratos automáticamente al cerrar oportunidades en CRM o completar pedidos.",
    trigger: "Evento de venta"
  },
  {
    id: 2,
    title: "Auto-envío",
    description: "Envía contratos para firma automáticamente según reglas de negocio.",
    trigger: "Aprobación interna"
  },
  {
    id: 3,
    title: "Auto-recordatorio",
    description: "Secuencias de follow-up automáticas para contratos pendientes de firma.",
    trigger: "Tiempo sin firmar"
  },
  {
    id: 4,
    title: "Auto-renovación",
    description: "Genera y envía contratos de renovación antes del vencimiento.",
    trigger: "Fecha de expiración"
  }
];

export const contractsFAQData = [
  {
    question: "¿Qué plataformas de firma electrónica soportan?",
    answer: "Ofrecemos integración nativa con DocuSign, Adobe Sign, SignaturIt y HelloSign. También soportamos cualquier plataforma mediante nuestra API abierta. Puedes usar múltiples proveedores simultáneamente según el tipo de contrato o región."
  },
  {
    question: "¿Los contratos firmados tienen validez legal?",
    answer: "Sí, todos los contratos firmados a través de nuestras integraciones tienen plena validez legal. Soportamos firma electrónica simple, avanzada y cualificada según eIDAS en Europa y normativas equivalentes en LATAM y USA."
  },
  {
    question: "¿Puedo usar mis propias plantillas de contrato?",
    answer: "Absolutamente. Puedes importar tus contratos existentes en Word o PDF y convertirlos en templates dinámicos. También ofrecemos una biblioteca de plantillas pre-diseñadas para servicios cloud comunes."
  },
  {
    question: "¿Cómo funciona la integración con el marketplace?",
    answer: "Cuando un cliente completa una compra en tu marketplace, el sistema genera automáticamente el contrato con los servicios seleccionados, lo presenta para firma y, una vez firmado, activa el aprovisionamiento. Todo sin intervención manual."
  },
  {
    question: "¿Qué pasa con contratos que requieren negociación?",
    answer: "El sistema soporta flujos de negociación con redlining, comentarios y múltiples versiones. Puedes definir qué cláusulas son negociables y cuáles son fijas, con aprobaciones multinivel para cambios fuera de política."
  }
];

export const contractsTestimonialData = {
  quote: "Automatizar nuestros contratos redujo el tiempo de cierre de 2 semanas a menos de 24 horas. La integración con firma electrónica eliminó completamente el papel y los errores de transcripción.",
  author: "",
  role: "Director Legal",
  company: "NOS",
  location: ""
};
